import Header from '../components/header';
import Footer from '../components/footer';
import Eachpart from "../components/eachpart";
import './services.css';
import { images } from '../components/importingScript';

const Services = () => {
  const services = [
    // 🎯 Core Digital & Branding
    { icon: './icon/icon-1.png', title: '3D Hologram', desc: 'Next-generation 3D projection for brand and product display.' },
    { icon: './icon/icon-2.png', title: 'AR Card', desc: 'Augmented Reality business cards for immersive branding.' },
    { icon: './icon/icon-3.png', title: 'IVR Number', desc: 'Automated Interactive Voice Response for smart call handling.' },
    { icon: './icon/icon-4.png', title: 'Mobile App', desc: 'Custom mobile apps to scale your business digitally.' },
    { icon: './icon/icon-5.png', title: 'Website', desc: 'Professional and responsive websites for any industry.' },
    { icon: './icon/icon-6.png', title: 'Dynamic Website', desc: 'Fully manageable and API-connected dynamic websites.' },
    { icon: './icon/icon-7.png', title: 'SEO', desc: 'Rank higher on Google with our expert SEO optimization services.' },
    { icon: './icon/icon-8.png', title: 'GMB', desc: 'Optimize your Google My Business profile to attract more customers.' },
    { icon: './icon/icon-9.png', title: 'Dedicated Employee', desc: 'Hire trained digital staff exclusively for your business.' },
    { icon: './icon/icon-10.png', title: 'Meta Ad', desc: 'Target the right audience with high-converting Meta (Facebook/Instagram) Ads.' },
    { icon: './icon/icon-11.png', title: 'Photo / Video Managed', desc: 'Professional photo and video content creation & management.' },
    { icon: './icon/icon-12.png', title: 'Google Profile Verified', desc: 'Get your Google Business Profile verified for trust & visibility.' },

    // 🤖 AI SERVICES
    { icon: './icon/ai-1.png', title: 'AI Digital Marketing Agency', desc: 'Run smarter Meta Ads with AI automation and analytics.' },
    { icon: './icon/ai-2.png', title: 'AI Workflow Automation', desc: 'Integrate Zapier, OpenAI, and Google Sheets to automate workflows.' },
    { icon: './icon/ai-3.png', title: 'AI Branding & Content Studio', desc: 'Build AI chatbots, generate ad creatives, and automate content management.' },

    // 💻 SOFTWARE SOLUTIONS
    { icon: './icon/soft-1.png', title: 'Custom Software Development', desc: 'Tailored software built to fit your business operations and goals.' },
    { icon: './icon/soft-2.png', title: 'ERP & CRM Systems', desc: 'Manage business data efficiently with modern ERP and CRM systems.' },
    { icon: './icon/soft-3.png', title: 'Cloud Integration', desc: 'Seamlessly connect your software to the cloud for scalability and security.' },
    { icon: './icon/soft-4.png', title: 'E-commerce Solutions', desc: 'Full-stack online store systems with secure payment and inventory management.' },
    { icon: './icon/soft-5.png', title: 'API Development & Integration', desc: 'Connect services with powerful, secure, and scalable APIs.' },
    { icon: './icon/soft-6.png', title: 'Automation Tools', desc: 'Develop custom automation tools to reduce manual workload.' },
    { icon: './icon/soft-7.png', title: 'SaaS Platform Development', desc: 'Launch your own Software-as-a-Service (SaaS) business platform.' },
  ];

  return (
    <>

      {/* Services Section */}
      <div className="container-xxl py-5">
        <div className="container">
          <div
            className="text-center mx-auto wow fadeInUp"
            data-wow-delay="0.1s"
            style={{
              maxWidth: '650px',
              visibility: 'visible',
              animationDelay: '0.1s',
              animationName: 'fadeInUp'
            }}
          >
            <p className="fs-5 fw-medium text-primary">Our Services</p>
            <h1 className="display-5 mb-5">AI + Software + Digital Marketing Solutions We Offer</h1>
          </div>

          <div className="row g-4">
            {services.map((service, index) => (
              <div
                className="col-lg-4 col-md-6 wow fadeInUp"
                key={index}
                data-wow-delay={`${0.1 * (index % 3 + 1)}s`}
                style={{
                  visibility: 'visible',
                  animationDelay: `${0.1 * (index % 3 + 1)}s`,
                  animationName: 'fadeInUp'
                }}
              >
                <div className="service-item position-relative h-100">
                  <div className="service-text rounded p-5 text-center">
                    <div
                      className="btn-square bg-light rounded-circle mx-auto mb-4 d-flex align-items-center justify-content-center"
                      style={{ width: '64px', height: '64px' }}
                    >
                      <img
                        className="img-fluid"
                        src={images[service.icon] || images['./icon/icon-5.png']}
                        alt={service.title}
                      />
                    </div>
                    <h5 className="mb-3">{service.title}</h5>
                    <p className="mb-0">{service.desc}</p>
                  </div>
                  <div className="service-btn rounded-0 rounded-bottom text-center">
                    <a className="text-primary fw-medium cur pointer" href="#">
                      Read More <i className="bi bi-chevron-double-right ms-2" />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

    </>
  );
};

export default Services;
